export default function calculateBusinessImage(biz, taken) {
  if (biz?.attributes?.mediumImageUrl) {
    return biz.attributes.mediumImageUrl;
  }
  const dict = { groomer: 46, trainer: 50, veterinary: 42 };
  const nonDuplicator = (v, type) => {
    if (dict[type] < (taken.length + 1)) {
      // nothing we can do but prevent stack overflow
      return v;
    }
    if (taken.includes(`/business_image_placeholders/${type}_${v}.jpg`)) {
      v += 1;
      if (v > dict[type]) {
        v = 1;
      }
      return nonDuplicator(v, type);
    }
    return v;
  };
  const imgNum = parseInt(biz.id.slice(-3), 16);
  const fract = (imgNum + 1) / 4096;
  let typePick = "groomer";
  const serviceTypes = biz?.include?.serviceTypes?.data?.map(d => d.attributes.name);
  if (Array.isArray(serviceTypes)  && serviceTypes.length) {
    const searchString = serviceTypes?.join("")?.toUpperCase();
    if (searchString.includes("GROOMING") && searchString.includes("TRAINING")) {
      const lastChar = parseInt(biz.id[biz.id.length - 1], 16) + 1;
      if (lastChar > 8) {
        typePick = "trainer";
      }
    } else if (searchString.includes("TRAINING")) {
      typePick = "trainer";
    } else if (searchString.includes("VETERINARY")) {
      typePick = "veterinary";
    }
  }
  let j = Math.ceil(fract * dict[typePick]);
  j = nonDuplicator(j, typePick);
  return `/business_image_placeholders/${typePick}_${j}.jpg`;
}
